function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.31 338.15C157.765 349.696 142.106 356.183 125.779 356.184C109.451 356.185 93.7912 349.7 82.245 338.155C70.6988 326.61 64.2117 310.951 64.2107 294.624C64.2098 278.296 70.6951 262.636 82.24 251.09L84 250L170 337L169.31 338.15Z",
  className: "extra-color-2"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.34 294.62C187.352 302.703 185.769 310.71 182.68 318.179C179.591 325.649 175.058 332.436 169.34 338.15L82.24 251.09C90.8507 242.482 101.82 236.62 113.762 234.245C125.704 231.871 138.081 233.09 149.33 237.749C160.579 242.408 170.194 250.298 176.959 260.42C183.725 270.543 187.337 282.445 187.34 294.62V294.62Z",
  className: "extra-color-2-darkened-1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.46 280.94L112.09 308.3",
  stroke: "white",
  strokeWidth: 10,
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.09 280.94L139.46 308.3",
  stroke: "white",
  strokeWidth: 10,
  strokeMiterlimit: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M446.08 437H164.66V436C170.89 394.4 198.31 358.11 235.97 340C249.14 365.42 274.37 381 304.97 381C335.57 381 360.76 365.33 373.97 340C391.91 348.6 408.91 362 420.8 377.28C434.293 394.64 443.008 415.229 446.08 437V437Z",
  className: "secondary"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M375.62 340.82C368.926 353.694 358.824 364.482 346.416 372.005C334.008 379.529 319.772 383.499 305.261 383.483C290.751 383.466 276.524 379.463 264.133 371.912C251.743 364.36 241.665 353.549 235 340.66C236.8 339.76 238.63 338.95 240.47 338.16L252.82 332.92C257.956 342.341 265.532 350.208 274.754 355.695C283.975 361.182 294.503 364.087 305.234 364.107C315.964 364.126 326.502 361.259 335.744 355.805C344.985 350.352 352.59 342.513 357.76 333.11L370 338.25C371.88 339.06 373.76 339.9 375.62 340.82Z",
  className: "secondary-lightened-1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M492 250V236H475V250H427V264H441.06L451.61 354H511.39L521.93 264H536V250H492Z",
  className: "extra-color-2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M519.13 286.23L511.16 354H451.36L519.13 286.23Z",
  className: "extra-color-2-darkened-1"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M467.5 285V317",
  stroke: "white",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M483.5 285V317",
  stroke: "white",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M498.5 285V317",
  stroke: "white",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 137.61V307H226.33C227.263 303.214 228.469 299.501 229.94 295.89C231.851 291.295 232.701 286.328 232.428 281.36C232.154 276.391 230.764 271.547 228.36 267.19C220.263 252.603 216.479 236.015 217.45 219.36C219.7 178.68 250 145.14 289 137.61Z",
  className: "primary-lightened-1"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M381.56 296.39C382.95 299.843 384.1 303.388 385 307H289V137.61C293.334 136.765 297.727 136.261 302.14 136.1C317.739 135.48 333.224 139.005 347.019 146.314C360.813 153.624 372.425 164.458 380.671 177.713C388.918 190.969 393.506 206.172 393.968 221.777C394.43 237.382 390.749 252.83 383.3 266.55C380.825 271.087 379.385 276.116 379.084 281.275C378.783 286.434 379.629 291.596 381.56 296.39V296.39Z",
  className: "primary"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M357.84 256H353V233H358.93C360.03 233 361.118 233.237 362.119 233.694C363.12 234.152 364.011 234.819 364.732 235.65C365.452 236.482 365.986 237.459 366.296 238.515C366.606 239.57 366.686 240.681 366.53 241.77L365.44 249.41C365.178 251.239 364.265 252.912 362.869 254.122C361.473 255.333 359.688 255.999 357.84 256V256Z",
  className: "primary-lightened-2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.16 254H257V231H251.07C249.97 231 248.882 231.237 247.881 231.694C246.88 232.152 245.989 232.819 245.268 233.65C244.548 234.482 244.014 235.459 243.704 236.515C243.394 237.57 243.314 238.681 243.47 239.77L244.56 247.41C244.822 249.239 245.735 250.912 247.131 252.122C248.527 253.333 250.312 253.999 252.16 254V254Z",
  className: "primary-lightened-2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M249.57 226.56L254.18 265.25C254.78 282.12 266.39 300.98 280.1 310.83C299.33 324.63 312.32 324.66 331.58 310.89L331.67 310.82C345.42 300.98 357.06 282.09 357.67 265.19L362.27 226.56C362.27 226.56 305 173.48 305.19 172.69C305.38 171.9 249.57 226.56 249.57 226.56Z",
  className: "primary-lightened-2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M393.11 229C393.11 231.36 393 233.69 392.81 236C384.719 238.371 376.331 239.577 367.9 239.58C351.729 239.52 335.871 235.111 321.99 226.816C308.108 218.52 296.713 206.643 289 192.43V143.69C294.623 142.557 300.344 141.991 306.08 142C317.508 141.996 328.824 144.243 339.383 148.614C349.941 152.984 359.536 159.392 367.618 167.471C375.7 175.55 382.111 185.142 386.485 195.7C390.859 206.257 393.11 217.572 393.11 229V229Z",
  className: "primary"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 143.69V192.43C276.65 219.17 250.8 238.37 219.7 239.54C219.276 236.053 219.059 232.543 219.05 229.03C219.044 208.911 226.011 189.412 238.765 173.852C251.519 158.292 269.271 147.633 289 143.69Z",
  className: "primary-lightened-1"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.53 218.71C137.987 175.532 158.55 135.619 191.122 106.926C223.693 78.2323 265.88 62.8659 309.276 63.889C352.671 64.9121 394.087 82.2495 425.27 112.446C456.453 142.642 475.113 183.48 477.53 226.82",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default __webpack_public_path__ + "static/media/removal_alert.a83d6c6d.svg";
export { SvgComponent as ReactComponent };